export default __webpack_public_path__ + "img/jtc/jtc6_700.jpg";